import * as React from 'preact/compat'
import Modal from '../Modal'
import GameCoversEditor from '../GameEditor/GameCoversEditor'
import { captureFetchException, loadStylesheet } from '../../common/helpers'
import commonCss from '../../../css/common.pcss.json'
import formCss from '../../../css/form.pcss.json'
import buttonsCss from '../../../css/buttons.pcss.json'
import styles from '../../../css/game-editor.pcss.json'
import type { TargetedEvent } from 'preact/compat'
import Api from '../../api'
import Loading from '../Loading'
import { showToast } from '../toast'

interface PropTypes {
  seriesId: number | string | null,
  onClose: () => void
}

interface StateTypes {
  loaded: boolean,
  name?: string,
  square_poster?: string,
  large_poster?: string
}

export default class SeriesCreator extends React.Component<PropTypes, StateTypes> {

  state: StateTypes = {
    loaded: false
  }

  modal = React.createRef<Modal>()

  componentWillMount() {
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('form')
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('game-editor');
  }

  componentDidMount() {
    if (this.props.seriesId === 'new' || this.props.seriesId === null) {
      return
    }
    Api.get<{
      name: string,
      square_poster: string,
      large_poster: string
    }>({ url: `game-series/info/${this.props.seriesId}` })
      .then(results => {
        this.setState({
          ...results,
          loaded: true,
        })
      })
      .catch((error) => {
        captureFetchException(error)
        showToast({
          type: 'error',
          text: 'Не удалось загрузить информацию о серии'
        })
        // noinspection JSIgnoredPromiseFromCall
        this.modal.current.close()
      })
  }

  submit = (event: TargetedEvent<HTMLFormElement>) => {
    event.preventDefault()
    const seriesId = this.props.seriesId ?? 'new'
    const formData = new FormData(event.currentTarget)
    formData.append('id', `${seriesId}`)
    Api.post<{
      success: boolean,
      link: string
    }>({ url: 'game-series/save', body: formData })
      .then(result => {
        window.location.href = result.link
      })
      .catch(error => {
        const verb = seriesId === 'new' ? 'создать' : 'сохранить';
        captureFetchException(error)
        showToast({
          text: `Не удалось ${verb} серию из-за непредвиденной ошибки`,
          type: 'error'
        })
      })
  }

  render() {
    const { loaded } = this.state
    const seriesId = this.props.seriesId ?? 'new'
    const isNew = seriesId === 'new'

    return <Modal ref={this.modal} showClose onClose={this.props.onClose} mobileFullScreen={true}>
      {!isNew && !loaded && <Loading/>}
      {(loaded || isNew) && <form onSubmit={this.submit}>
        <h1 className={commonCss['h3']} style='margin-bottom: 32px;'>
          {isNew ? 'Создание серии' : 'Редактирование серии'}
        </h1>
        <div
          className={formCss['form-group']}
          style='margin-bottom: 32px; display: flex; flex-direction: column; row-gap: 16px;'
        >
          <label>Название серии</label>
          <input type='text' name='name' className={formCss['input']} value={this.state.name || ''} required min={3}/>
        </div>
        <div className={styles['covers-editor-container']}>
          <h2 className={commonCss['h3']}>Обложки</h2>
          <GameCoversEditor
            covers={{
              square_poster: this.state.square_poster || '',
              large_poster: this.state.large_poster || ''
            }}
            hideLabels
          />
        </div>
        <button type='submit' className={buttonsCss['primary']} style='margin-top: 56px'>Сохранить</button>
      </form>}
    </Modal>
  }
}
